/**
 * ema-parabolic-page.js
 *
 * 20/8 EMA Parabolic strategy:
 *   EMA(8) and EMA(20) bands (on high/low) fully separated — a parabolic
 *   expansion — with price pulled back to the near edge of the 8-band and
 *   RSI(20) confirming momentum.
 *   Long:  ema8Low > ema20High + price < ema8High + RSI(20) > 60
 *   Short: ema8High < ema20Low + price > ema8High + RSI(20) < 40
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchEmaParabolicData } from '../services/server-api';

const TF_LABELS = { weekly: 'Weekly', daily: 'Daily', fourHour: '4H' };

function renderDetails(entry) {
  const fmt = v => v != null ? `$${v.toLocaleString(undefined, { maximumFractionDigits: 4 })}` : '—';
  const rsiVal = entry.rsi20 != null ? entry.rsi20.toFixed(1) : '—';
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">8 EMA High / Low</span>
        <span className="mtf-ind-value zone">{fmt(entry.ema8High)} / {fmt(entry.ema8Low)}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">20 EMA High / Low</span>
        <span className="mtf-ind-value zone">{fmt(entry.ema20High)} / {fmt(entry.ema20Low)}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">RSI(20)</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>{rsiVal}</span>
      </div>
    </>
  );
}

function EmaParabolicPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      '20/8 EMA Parabolic',
        icon:       '🚀',
        subtitle:   '8 & 20 EMA bands (high/low) fully separated · price pulled back to 8-band edge · RSI(20) 60/40',
        fetchFn:    fetchEmaParabolicData,
        timeframes: ['weekly', 'daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default EmaParabolicPage;
